/* istanbul ignore file */

import React from 'react';
import { useModalManager } from '@/components/common/Modal';
import FeedbackModal from './FeedbackModal';

export type { IStaffer } from './FeedbackModal';

interface FeedbackFormProps {
  className?: string;
  currentPageUrl: string;
  staffer: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

const FeedbackForm = ({
  className,
  currentPageUrl,
  staffer,
}: FeedbackFormProps) => {
  const { isOpen, open, close } = useModalManager();

  return (
    <>
      <button
        aria-controls="feedback-modal"
        aria-haspopup="dialog"
        className={`dropdown-item purple full-size tw-cursor-pointer ${className || ''}`}
        type="button"
        onClick={open}
      >
        Feedback
      </button>
      <FeedbackModal
        close={close}
        currentPageUrl={currentPageUrl}
        isOpen={isOpen}
        staffer={staffer}
      />
    </>
  );
};

export default FeedbackForm;
